import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router'
import { Icon } from '#app/components/ui/icon.tsx'

const DISMISS_KEY = 'feedback-banner-dismissed'

/** Thin, in-flow nudge toward the feedback page; shows once per browser session. */
export function FeedbackBanner() {
	const location = useLocation()
	// start hidden so SSR/hydration match; reveal after checking sessionStorage
	const [visible, setVisible] = useState(false)

	useEffect(() => {
		if (!sessionStorage.getItem(DISMISS_KEY)) setVisible(true)
	}, [])

	if (!visible || location.pathname === '/feedback') return null

	function dismiss() {
		sessionStorage.setItem(DISMISS_KEY, '1')
		setVisible(false)
	}

	return (
		<div className="relative flex items-center justify-center gap-2 border-b border-emerald-200 bg-emerald-50 px-10 py-2 text-center text-sm text-emerald-900 dark:border-emerald-900 dark:bg-emerald-950 dark:text-emerald-100">
			<Icon name="sms" className="h-4 w-4 shrink-0" aria-hidden="true" />
			<Link
				to="/feedback"
				className="font-medium underline-offset-2 hover:underline"
			>
				Have feedback? Let us know →
			</Link>
			<button
				type="button"
				onClick={dismiss}
				aria-label="Dismiss feedback banner"
				className="absolute right-2 rounded p-1 text-emerald-700 hover:bg-emerald-100 dark:text-emerald-200 dark:hover:bg-emerald-900"
			>
				<Icon name="cross-1" className="h-4 w-4" aria-hidden="true" />
			</button>
		</div>
	)
}
